import {useEffect, useState} from "react";
import type { ContextProps } from '../../../../types';
import {SYSTEM_TYPES} from "../../../Library/libraryConstants";
import {getSystemTypeTextByValue} from "../../../Library/libraryUtility";
import {ownLoanHistoryItemModel} from "./ownLoanHistoryFactory";
import {ownLoanHistoryApi} from "./ownLoanHistoryApi";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {SearchResultsContainer} from "../../../../Components/SearchResults";
import {PageTitle} from "../../../../Components/Landmarks";
import {OwnLoanHistorySearchFormView} from "./OwnLoanHistorySearchFormView";
import {LayoutFullWidth} from "../../../../Components/Layout";
import {OwnLoanHistoryView} from "./OwnLoanHistoryView";
import {GridCell, gridConstants, GridContainer} from "../../../../Components/Grid";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";

export const OwnLoanHistoryContainer = ({
                                            ownLoanHistorySearchCriteria,
                                            handleApiCall,
                                            handleSetOwnLoanHistorySearchCriteria,
                                            isLoading,
                                            redirect,
                                        }: ContextProps) => {

        const [ownLoanHistoryItems, setOwnLoanHistoryItems] = useState<Record<string, any>[]>([]);
        const [ownLoanSearchDropDowns, setOwnLoanSearchDropDowns] = useState<Record<string, unknown> | null>(null);
        const [totalRecords, setTotalRecords] = useState(0);

        const loadLoanHistoriesResults = (result: { data: Record<string, any>[]; totalRecords: number }) => {
            const loanHistoryItems = result.data.map((ownLoanHistoryItem: Record<string, any>) => ownLoanHistoryItemModel(ownLoanHistoryItem));
            setOwnLoanHistoryItems(loanHistoryItems);
            setTotalRecords(result.totalRecords);
        };

        const handleExportLoansClick = () => {
            if(isArrayNullOrEmpty(ownLoanHistoryItems))
                alert("Search criteria has no results. Adjust your search and try again.")
            else
                handleApiCall(() => ownLoanHistoryApi.getOwnLoanHistoryReport(ownLoanHistorySearchCriteria));
        }

        const handleGetOwnLoanSearchDropDowns = () => {
            handleApiCall(() => ownLoanHistoryApi.getDropdownListsForOwnLoanSearch(), (results: Record<string, unknown>) => setOwnLoanSearchDropDowns(results));
        }

        useEffect(() => {

            if (!ownLoanSearchDropDowns)
                handleGetOwnLoanSearchDropDowns();

            if (!ownLoanHistorySearchCriteria) return;

            if (ownLoanHistorySearchCriteria.loadSearchResults) {
                const criteriaToSend = {
                    ...ownLoanHistorySearchCriteria,
                    isOwnLoanHistory: true
                };
                handleApiCall(
                    () => ownLoanHistoryApi.getOwnLoanHistory(criteriaToSend),
                    loadLoanHistoriesResults
                );
            }

        }, [ownLoanHistorySearchCriteria]);

        if (!ownLoanHistorySearchCriteria || isNullOrUndefined(ownLoanSearchDropDowns)) return null;

        return <>
            <PageTitle h1={`${getSystemTypeTextByValue(SYSTEM_TYPES.Own.toString())} History`}/>
            {
                ownLoanSearchDropDowns && 
                <div className={`searchBox`}>
                    <div className={`searchBox__title`}>Search for Loan History</div>
                    <OwnLoanHistorySearchFormView
                        ownLoanHistorySearchCriteria={ownLoanHistorySearchCriteria}
                        ownLoanSearchDropDowns={ownLoanSearchDropDowns}
                        handleSetOwnLoanHistorySearchCriteria={handleSetOwnLoanHistorySearchCriteria}
                        isLoading={isLoading}
                    />
                </div>
            }

            <LayoutFullWidth>
                <SearchResultsContainer title="Own History Results">
                    <div>
                        <GridContainer isReverseOrder hasMarginX className={`form__header`}>
                            <GridCell
                                medium_columns={gridConstants.column.ONE}>
                                <ButtonLinkStyle
                                    isCollapsed
                                    label={`Export Own History`}
                                    name="btnExportHistory"
                                    onClick={handleExportLoansClick}
                                />
                            </GridCell>
                        </GridContainer>
                        <OwnLoanHistoryView
                            ownLoanHistoryItems={ownLoanHistoryItems}
                            ownLoanHistorySearchCriteria={ownLoanHistorySearchCriteria}
                            handleSetOwnLoanHistorySearchCriteria={handleSetOwnLoanHistorySearchCriteria}
                            redirect={redirect}
                            totalRecords={totalRecords}
                        />
                    </div>
                </SearchResultsContainer>
            </LayoutFullWidth>
        </>;
    }
;
